module.exports = __webpack_public_path__ + "img/calendar-5-mob.d0685a6.jpg";